module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_8017.58a9fbc6.png";